import styles from "./PositionHeader.module.css"
import { AiOutlineArrowLeft } from "react-icons/ai"
import { Link } from "react-router-dom";


const PositionHeader = () => {
  return (
    <div className={styles.position_header}>
    <Link to="/analyticsv2">
        
    <AiOutlineArrowLeft size={25}  />
    </Link>
    <span>Liquidity Position</span>
    <span>{""}</span>
</div>
  )
}

export default PositionHeader